export default __webpack_public_path__ + "static/media/lock.8a0b851f.svg";